module.exports = __webpack_public_path__ + "static/media/air.905a1207.svg";